import script from "./CreateTestsWriter.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateTestsWriter.vue?vue&type=script&setup=true&lang=js"

import "./CreateTestsWriter.vue?vue&type=style&index=0&id=582fb330&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-582fb330"]])

export default __exports__